module.exports = __webpack_public_path__ + "img/Credit.3b57470f.png";